import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Two-tier stone garden fountain on a 2x2 tile patch, ~1.6 m high: an
// octagonal basin, a centre column carrying a smaller upper bowl, a thin
// rising water column and water discs in both tiers.
const STONE = "#8d8a85";
const STONE_LIGHT = "#9b9791";
const WATER = "#6fa8c0";

export const gardenFountain = defineModel({
  id: "garden-fountain",
  batchId: "modern",
  name: "Garden fountain",
  tags: ["modern", "outdoor", "garden", "fountain", "water"],
  summary: "A two-tier octagonal stone fountain about 1.6 metres high.",
  description:
    "A two-tier stone fountain of the Modern Living kit: ~1.6 m high on a " +
    "2x2 tile patch — an octagonal basin with a water disc, a centre column " +
    "carrying a smaller upper bowl, and a thin water column rising from it.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // Octagonal plinth and basin wall.
      {
        geometry: new THREE.CylinderGeometry(0.95, 0.95, 0.08, 8),
        color: STONE_LIGHT,
        position: [0, 0.04, 0],
      },
      {
        geometry: new THREE.CylinderGeometry(0.85, 0.88, 0.28, 8),
        color: STONE,
        position: [0, 0.22, 0],
      },
      // Water disc filling the basin, standing just proud of the rim.
      {
        geometry: new THREE.CylinderGeometry(0.76, 0.76, 0.06, 8),
        color: WATER,
        position: [0, 0.36, 0],
      },
      // Centre column.
      {
        geometry: new THREE.CylinderGeometry(0.11, 0.16, 0.62, 8),
        color: STONE,
        position: [0, 0.64, 0],
      },
      // Upper bowl and its water disc.
      {
        geometry: new THREE.CylinderGeometry(0.4, 0.28, 0.14, 8),
        color: STONE,
        position: [0, 1.02, 0],
      },
      {
        geometry: new THREE.CylinderGeometry(0.34, 0.34, 0.04, 8),
        color: WATER,
        position: [0, 1.1, 0],
      },
      // Thin water column rising from the upper bowl.
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.42, 6),
        color: WATER,
        position: [0, 1.31, 0],
      },
      // Water crown at the top of the jet.
      {
        geometry: new THREE.SphereGeometry(0.07, 6, 5),
        color: WATER,
        position: [0, 1.53, 0],
      },
    ];
  },
  animations: [],
});
